<!-- Screen Menu -->
<div class="screen-menu">
  <nav id="sidebar-menu">
    <div class="logo-mi-leapmotor">
      <a href="/home">
        <img src="assets/images/logo-mi-leapmotor-pos.svg" alt="Mi Leapmotor">
      </a>
    </div>
    <div class="header-user" *ngIf="this.user != null">
      <div *ngIf="this.user.Name"><strong>Hola,</strong> {{this.user.Name}} {{this.user.Surname}}</div>
    </div>
    <div *ngIf="items">
      <ul class="list-unstyled">
        <li>
          <ul class="navbar-nav" app-menu id="MainMenu" [items]="items"></ul>
        </li>
      </ul>
    </div>
    <div class="logout-container">
      <a (click)="logout()" class="logout-link">
        Cerrar Sesión
      </a>
    </div>
  </nav>
</div>
<!-- Mobile Menu -->
<div class="mobile-menu">
  <div class="offcanvas offcanvas-start" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1"
    id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
    <div class="offcanvas-body">
      <div class="cont-btn-close">
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button></div>
      <div class="logo-mi-leapmotor">
        <img src="assets/images/logo-mi-leapmotor-pos.svg" alt="Mi Leapmotor">
      </div>
      <div class="header-user" *ngIf="this.user != null">
        <div *ngIf="this.user.Name"><strong>Hola,</strong> {{this.user.Name}} {{this.user.Surname}}</div>
      </div>
      <div *ngIf="items" class="offcanvas-menu">
        <ul class="list-unstyled">
          <li>
            <ul class="navbar-nav" app-menu id="MainMenu" [items]="items"></ul>
          </li>
        </ul>
        <div class="logout-container">
          <a (click)="logout()" class="logout-link">
            Cerrar Sesión
          </a>
        </div>
      </div>
    </div>
  </div>
</div>